(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neechy-product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#size-guide"]');
  if (!link) return;
  const guide = document.getElementById('size-guide');
  if (guide) guide.open = true;
});
  } catch(e) { console.error(e); }
})();

})();
